export const SERVICES = [
  {
    id: "photography",
    icon: "Camera",
    title: "Photography",
    tag: "Photo",
    desc: "Editorial, brand, and portrait photography that captures light, story, and soul with intention.",
    image:
      "https://images.unsplash.com/photo-1516035069371-29a1b244cc32?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "videography",
    icon: "Video",
    title: "Videography",
    tag: "Video",
    desc: "Cinematic films and brand stories crafted frame by frame to move both hearts and markets.",
    image:
      "https://images.unsplash.com/photo-1612548403247-aa2873e9422d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "drone",
    icon: "Plane",
    title: "Drone Footage",
    tag: "Video",
    desc: "Sweeping aerial perspectives that reveal scale, place, and the grandeur of your vision.",
    image:
      "https://images.unsplash.com/photo-1609779340167-207589f3f94f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "design",
    icon: "PenTool",
    title: "Graphic Design",
    tag: "Design",
    desc: "Identity systems, print, and digital design built on typography, restraint, and craft.",
    image:
      "https://images.unsplash.com/photo-1676285437303-744ef82a0263?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "social",
    icon: "Share2",
    title: "Social Media",
    tag: "Social Media",
    desc: "Content strategy and management that grows presence with consistency and purpose.",
    image:
      "https://images.unsplash.com/photo-1724862936518-ae7fcfc052c1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "web",
    icon: "Code",
    title: "Website Development",
    tag: "Website",
    desc: "Fast, elegant, conversion-minded websites engineered to reflect the very best of you.",
    image:
      "https://images.unsplash.com/photo-1531297484001-80022131f5a1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
];

export const VALUES = [
  { n: "01", title: "Faith", desc: "Every project begins in prayer and purpose. We work as unto the Lord." },
  { n: "02", title: "Excellence", desc: "Good enough is never the standard. We pursue craft in every detail." },
  { n: "03", title: "Creativity", desc: "Made in the image of a Creator, we make things that are beautiful and true." },
  { n: "04", title: "Impact", desc: "We build brands that serve people and stories that endure." },
];

export const PORTFOLIO = [
  {
    id: 1,
    client: "Almeida's Home Service",
    category: "Kitchen Remodel",
    tag: "Photo",
    image: "/media/almeida-kitchen-new.webp",
    span: "wide",
  },
  {
    id: 2,
    client: "Fred's Flooring Pro",
    category: "Hardwood Floor Installation",
    tag: "Photo",
    image: "/media/fred-hardwood-dark-new.png",
    span: "tall",
  },
  {
    id: 3,
    client: "Almeida's Home Service",
    category: "Bathroom Renovation",
    tag: "Photo",
    image: "/media/almeida-bathroom-new.webp",
    span: "normal",
  },
  {
    id: 4,
    client: "Almeida's Home Service",
    category: "Covered Patio",
    tag: "Photo",
    image: "/media/almeida-patio.png",
    span: "wide",
  },
  {
    id: 5,
    client: "Fred's Flooring Pro",
    category: "Hardwood Flooring",
    tag: "Photo",
    image: "/media/fred-hardwood-light.png",
    span: "normal",
  },
  {
    id: 6,
    client: "Almeida's Home Service",
    category: "Living Room Remodel",
    tag: "Photo",
    image: "/media/almeida-living.png",
    span: "tall",
  },
];

export const FILTERS = ["All", "Photo", "Video", "Design", "Social Media", "Website"];
